export default "__VITE_ASSET___rbhhmHc__"